import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { GestorContenidoService } from 'src/app/services/gestor-contenido.service';

@Component({
    selector: 'app-detalle-publicacion',
    templateUrl: './detalle-publicacion.component.html',
    styles: [],
    standalone: false
})
export class DetallePublicacionComponent implements OnInit {
  idPost: number = null;
  tipoPost: string = null;
  post: any = null;
  contenidoPost: any = null;
  listaRecomendados: any[] = [];
  cantidadMostrar: number = 2;
  url: string = '';
  enlaceFacebook: string = '';
  enlaceTwitter: string = '';

  constructor(private _gestorContenido: GestorContenidoService,
    private _route: ActivatedRoute) {
      window.scroll(0, 0); 
  }

  ngOnInit(): void {
    const host = window.location.host;
    const protocol = window.location.protocol;
    const path = window.location.pathname;
    this.url = `${protocol}//${host}${path}`;
    this.enlaceFacebook = `https://www.facebook.com/sharer/sharer.php?u=${this.url}`;
    this.getIdPost();
  }

  getIdPost() {
    this._route.params.subscribe((params: Params) => {
      this.idPost = params["id"];
      this.tipoPost = params["tipo"];
      if (this.idPost && this.tipoPost) {
        if(this.tipoPost == 'articulo'){
          this.getArticuloPorId();
          this.getArticulosPrincipales();
        }
        else if(this.tipoPost == 'noticia'){
          this.getNoticiaPorId();
          this.getNoticiasPrincipales();
        }
      }
    });
  }
  
  cargarUrlTwitter(){
    this.enlaceTwitter = `https://twitter.com/intent/tweet?url=${this.url}&text=${this.post?.titulo}`;
  }

  getArticuloPorId(){
    this._gestorContenido.getArticuloPorId(this.idPost).subscribe(
      (response: any) => {
        const page = response;
        this.post = page.data;
        this.contenidoPost = this.post.body;
        this.cargarUrlTwitter();
      },
      (error) => {
      }
    );
  }

  getNoticiaPorId(){
    this._gestorContenido.getNoticiaPorId(this.idPost).subscribe(
      (response: any) => {
        const page = response;
        this.post = page.data;
        this.contenidoPost = this.post.body;
        this.cargarUrlTwitter();
      },
      (error) => {
      }
    );
  }

  getNoticiasPrincipales(){
    this._gestorContenido.getNoticiasPrincipales(0).subscribe(
      (response: any) => {
        const page = response;
        this.listaRecomendados = page.rows.slice(0,this.cantidadMostrar);
      },
      (error) => {
      }
    );
  }

  getArticulosPrincipales(){
    this._gestorContenido.getArticulosPrincipales(0).subscribe(
      (response: any) => {
        const page = response;
        this.listaRecomendados = page.rows.slice(0,this.cantidadMostrar);
      },
      (error) => {
      }
    );
  }

  transformarTitulo(titulo: string){
    return titulo.replace(/ /g, '_');
  }
}